import script from "./TaskInfoModal.vue?vue&type=script&setup=true&lang=js"
export * from "./TaskInfoModal.vue?vue&type=script&setup=true&lang=js"

import "./TaskInfoModal.vue?vue&type=style&index=0&id=78be6214&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78be6214"]])

export default __exports__